import { all, call, fork, put, takeLeading } from "typed-redux-saga";
import { Action, addEditProjectDialogActions } from "./add-edit-project-dialog-store";
import { projectListActions as projectListActions } from "../../project-list-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { ConfiguratorService, ContactPersonService, Model_ContactPersonVisibilityGet } from "src/backend/openapi/v1";

export function* createModifyProject(action: ReturnType<typeof addEditProjectDialogActions.createModifyProjectRequest>) {
  try {
    const result = yield* call(ConfiguratorService.putApiV1ConfiguratorProjects, action.payload.data.projectId, action.payload.data);

    // Reload project list after adding or updating project
    yield* put(projectListActions.setShouldReload(true));
    action.payload.callBack(true, result.projectId);
  } catch (error) {
    yield put(errorActions.addError(error));
    action.payload.callBack(false);
  }
}

export function* watchCreateModifyProject() {
  yield takeLeading(Action.CreateModifyProjectRequest, createModifyProject);
}

export function* getProject(action: ReturnType<typeof addEditProjectDialogActions.getProjectrequest>) {
  try {
    const result = yield* call(ConfiguratorService.getApiV1ConfiguratorProjects1, action.payload.projectId);
    action.payload.callBack(true, result);
  } catch (error) {
    yield put(errorActions.addError(error));
    action.payload.callBack(false);
  }
}

export function* watchGetProject() {
  yield takeLeading(Action.GetProjectRequest, getProject);
}

export function* getVisibilityContactPersons() {
  try {
    const result: Model_ContactPersonVisibilityGet[] = yield call(ContactPersonService.getApiV1ContactPersonVisibility);
    yield put(addEditProjectDialogActions.getVisibilityContactPersonsSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(addEditProjectDialogActions.getVisibilityContactPersonsFail());
  }
}

export function* watchGetVisibilityContactPersons() {
  yield takeLeading(Action.GetVisibilityContactPersonsRequest, getVisibilityContactPersons);
}

export function* addEditProjectDialogSaga() {
  yield* all([fork(watchCreateModifyProject), fork(watchGetProject), fork(watchGetVisibilityContactPersons)]);
}
